<span
    class="h6"
    role="heading"
    aria-level="2"
    >{{ i18n._942_CHALLENGE_RESPONSE | translate }}</span
>
<p>
    {{
        i18n._943_ENTER_YOUR_USERNAME_AND_CLICK_THE__RETRIEVE_QUESTION__BUTTON_TO_RETRIEVE_YOUR_QUESTION__ONCE_YOUR_QUESTION_IS_RETRIEVED__ENTER_YOUR_ANSWER_AND_CLICK_THE__VERIFY_ANSWER__BUTTON__IF_YOUR_ANSWER_IS_CORRECT_YOU_WILL_THEN_BE_ABLE_TO_CHANGE_YOUR_PASSWORD_
            | translate
    }}
</p>
<span
    class="sr-only"
    id="authQuestionResetLobby"
    tabindex="-1"
></span>
<div class="container-fluid pr-0 pl-0">
    <form
        [name]="form.name"
        #ngForm="ngForm"
        [ngSwitch]="step"
    >
        <ng-container *ngSwitchCase="Steps.USERNAME">
            <div class="row">
                <div class="col-12 col-sm-8 mr-auto ml-auto form-group">
                    <label [for]="form.fields.USERNAME.id">{{
                        form.fields.USERNAME.label | translate
                    }}</label>
                    <input
                        type="text"
                        class="form-control"
                        [name]="form.fields.USERNAME.name"
                        [placeholder]="
                            form.fields.USERNAME.placeholder | translate
                        "
                        [disabled]="form.submitted"
                        [(ngModel)]="username"
                        [field]="form.fields.USERNAME"
                    />
                    <div
                        class="alert alert-warning mt-1 mb-0"
                        role="alert"
                        *ngIf="form.errors.USERNAME"
                    >
                        {{ form.errors.USERNAME }}
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="Steps.ANSWER">
            <div class="row">
                <div class="col-12 col-sm-8 mr-auto ml-auto form-group">
                    <label [for]="form.fields.SECURITY_QUESTION.id">
                        {{ form.fields.SECURITY_QUESTION.label | translate }}
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        [name]="form.fields.SECURITY_QUESTION.name"
                        [placeholder]="
                            form.fields.ANSWER.placeholder | translate
                        "
                        readonly
                        [(ngModel)]="securityQuestion.question"
                        [field]="form.fields.SECURITY_QUESTION"
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-8 mr-auto ml-auto form-group">
                    <label [for]="form.fields.ANSWER.id">{{
                        form.fields.ANSWER.label | translate
                    }}</label>
                    <input
                        type="text"
                        class="form-control"
                        [name]="form.fields.ANSWER.name"
                        [placeholder]="
                            form.fields.ANSWER.placeholder | translate
                        "
                        [disabled]="form.submitted"
                        [(ngModel)]="resetPasswordSecQuesAnsModel.answer"
                        [field]="form.fields.ANSWER"
                    />
                    <div
                        class="alert alert-warning mt-1 mb-0"
                        role="alert"
                        *ngIf="form.errors.ANSWER"
                    >
                        {{ form.errors.ANSWER }}
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="Steps.PASSWORD">
            <div class="row">
                <div class="col-12 col-sm-8 mr-auto ml-auto form-group">
                    {{
                        i18n._872_ANSWER_VERIFIED__PLEASE_CHANGE_YOUR_PASSWORD_BELOW_
                            | translate
                    }}
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-8 mr-auto ml-auto form-group">
                    <label [for]="form.fields.NEW_PASSWORD.id">{{
                        form.fields.NEW_PASSWORD.label | translate
                    }}</label>
                    <input
                        type="password"
                        class="form-control"
                        autocomplete="new-password"
                        [name]="form.fields.NEW_PASSWORD.name"
                        [placeholder]="
                            form.fields.NEW_PASSWORD.placeholder | translate
                        "
                        [disabled]="form.submitted"
                        [(ngModel)]="resetPasswordModel.password"
                        [field]="form.fields.NEW_PASSWORD"
                    />
                    <div
                        class="alert alert-warning mt-1 mb-0"
                        role="alert"
                        *ngIf="form.errors.NEW_PASSWORD"
                    >
                        {{ form.errors.NEW_PASSWORD }}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-sm-8 mr-auto ml-auto form-group">
                    <label [for]="form.fields.NEW_PASSWORD_CONFIRM.id">{{
                        form.fields.NEW_PASSWORD_CONFIRM.label | translate
                    }}</label>
                    <input
                        type="password"
                        class="form-control"
                        autocomplete="new-password"
                        [name]="form.fields.NEW_PASSWORD_CONFIRM.name"
                        [placeholder]="
                            form.fields.NEW_PASSWORD_CONFIRM.placeholder
                                | translate
                        "
                        [disabled]="form.submitted"
                        [(ngModel)]="resetPasswordModel.passwordConfirm"
                        [requiredWhenValidator]="form.fields.NEW_PASSWORD.id"
                        [markAsRequired]="true"
                        [textEqualValidator]="form.fields.NEW_PASSWORD.id"
                        [field]="form.fields.NEW_PASSWORD_CONFIRM"
                    />
                    <div
                        class="alert alert-warning mt-1 mb-0"
                        role="alert"
                        *ngIf="form.errors.NEW_PASSWORD_CONFIRM"
                    >
                        {{ form.errors.NEW_PASSWORD_CONFIRM }}
                    </div>
                </div>
            </div>
        </ng-container>
        <div class="row">
            <div class="col-12 col-sm-8 mr-auto ml-auto">
                <div
                    class="alert alert-info"
                    role="alert"
                    *ngIf="step === Steps.PASSWORD && form.submitted"
                >
                    {{ i18n._928_PLEASE_WAIT_ | translate }}
                </div>
                <div
                    class="alert alert-warning"
                    role="alert"
                    *ngIf="failure"
                >
                    {{ form.serverError | translate }}
                </div>
                <div
                    class="alert alert-success"
                    role="alert"
                    *ngIf="success"
                >
                    {{
                        i18n._871_THE_PASSWORD_HAS_BEEN_SUCCESSFULLY_CHANGED_
                            | translate
                    }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="float-right">
                    <ng-container *ngIf="!success; else successTpl">
                        <button
                            type="button"
                            class="btn btn-secondary mr-2"
                            (click)="activeModal.close()"
                        >
                            {{ i18n._121_CANCEL | translate }}
                        </button>
                        <button
                            type="submit"
                            class="btn btn-primary"
                            (click)="onSubmit()"
                            [disabled]="form.submitted"
                        >
                            <ng-container [ngSwitch]="step">
                                <ng-container *ngSwitchCase="Steps.USERNAME">
                                    {{
                                        i18n._944_RETRIEVE_QUESTION | translate
                                    }}
                                </ng-container>
                                <ng-container *ngSwitchCase="Steps.ANSWER">
                                    {{ i18n._945_VERIFY_ANSWER | translate }}
                                </ng-container>
                                <ng-container *ngSwitchCase="Steps.PASSWORD">
                                    {{ i18n._111_CHANGE_PASSWORD | translate }}
                                </ng-container>
                            </ng-container>
                        </button>
                    </ng-container>
                    <ng-template #successTpl>
                        <button
                            type="button"
                            class="btn btn-primary"
                            (click)="activeModal.close()"
                        >
                            {{ i18n._763_CLOSE | translate }}
                        </button>
                    </ng-template>
                </div>
            </div>
        </div>
    </form>
</div>
